import React, { useState } from 'react';

const IconPickerModal = ({ show, onClose, onSelect, icons, initialIcon }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedIcon, setSelectedIcon] = useState(initialIcon || '');

    if (!show) return null;

    const filteredIcons = icons.filter(icon =>
        icon.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleConfirm = () => {
        if (selectedIcon) {
            onSelect(selectedIcon);
            onClose();
        }
    };

    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal icon-picker-modal" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3>Select Icon</h3>
                    <button className="admin-modal-close" onClick={onClose}>×</button>
                </div>

                <div className="icon-picker-search-container">
                    <div className="icon-picker-search-wrapper">
                        <i className="fa fa-search search-icon"></i>
                        <input
                            type="search"
                            placeholder="Search icons (car, home, bike...)"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="icon-picker-search-input"
                            autoFocus
                        />
                    </div>
                </div>

                <div className="admin-modal-body icon-picker-scrollable">
                    <div className="icon-grid-modern">
                        {filteredIcons.length > 0 ? (
                            filteredIcons.map((icon, index) => (
                                <div
                                    key={index}
                                    className={`icon-grid-card ${selectedIcon === icon.url ? 'active' : ''}`}
                                    onClick={() => setSelectedIcon(icon.url)}
                                    title={icon.name}
                                >
                                    <div className="icon-square-box">
                                        <img src={icon.url} alt={icon.name} loading="lazy" />
                                        {selectedIcon === icon.url && (
                                            <div className="selection-checkmark">
                                                <i className="fa fa-check"></i>
                                            </div>
                                        )}
                                    </div>
                                    <span className="icon-tiny-label">{icon.name}</span>
                                </div>
                            ))
                        ) : (
                            <div className="no-icons-message">
                                <i className="fa fa-exclamation-circle"></i>
                                <p>No icons matching "{searchTerm}"</p>
                            </div>
                        )}
                    </div>
                </div>

                <div className="admin-modal-footer">
                    <button className="admin-btn admin-btn-outline" onClick={onClose}>Cancel</button>
                    <button
                        className="admin-btn admin-btn-primary"
                        style={{ marginLeft: 'auto' }}
                        onClick={handleConfirm}
                        disabled={!selectedIcon}
                    >
                        Confirm Selection
                    </button>
                </div>
            </div>
        </div>
    );
};

export default IconPickerModal;
